import { defineAsyncComponent } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { Actions, Subjects } from '@/rules/abilityTypes'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/project/:slug(.*)?',
    name: 'project',
    component: defineAsyncComponent(() => import('../views/ProjectList.vue')),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT,
      action: Actions.READ
    }
  },
  {
    path: '/project/create/:slug(.*)?',
    name: 'projectCreate',
    component: () => import('../views/ProjectEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT_CREATE,
      action: Actions.WRITE
    }
  },
  {
    path: '/project/:projectId/:slug(.*)?',
    name: 'projectEdit',
    component: () => import('../views/ProjectEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT,
      action: Actions.WRITE
    }
  },
  {
    path: '/projectuser/:date/:slug(.*)?',
    name: 'projectuser',
    component: defineAsyncComponent(() => import('../views/ProjectUser.vue')),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT_USER,
      action: Actions.READ
    }
  },
  {
    path: '/userproject/:date/:slug(.*)?',
    name: 'userProject',
    component: defineAsyncComponent(() => import('../views/UserProject.vue')),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.USER_PROJECT,
      action: Actions.READ
    }
  },
  {
    path: '/resource_plan/:projectId/:slug(.*)?',
    name: 'resourcePlan',
    component: defineAsyncComponent(() => import('../views/ResourcePlan.vue')),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.RESOURCE_PLAN,
      action: Actions.READ
    }
  },
  {
    path: '/assign/:projectId/:assignId?/:slug(.*)?',
    name: 'assign',
    component: () => import('../views/ResourcePlan/AddNamedAssign.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.ASSIGN_BY_VOLUMED,
      action: Actions.WRITE
    }
  },
  {
    path: '/assignByVolumed/:projectId/:volumedAssignId/:assignId?/:slug(.*)?',
    name: 'assignByVolumed',
    component: () => import('../views/ResourcePlan/AddNamedAssign.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.ASSIGN_BY_VOLUMED,
      action: Actions.WRITE
    }
  },
  {
    path: '/volumedAssign/:projectId/:volumedAssignId?/:slug(.*)?',
    name: 'volumedAssign',
    component: () => import('../views/ResourcePlan/AddVolumedAssign.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.VOLUMED_ASSIGN,
      action: Actions.WRITE
    }
  },
  {
    path: '/add_project/:userId/:date/:slug(.*)?',
    name: 'addProject',
    component: () => import('../views/AddProject.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.ADD_PROJECT,
      action: Actions.WRITE
    }
  },
  {
    path: '/project_sales_and_cost/:projectId/:slug(.*)?',
    name: 'projectSalesAndCost',
    component: defineAsyncComponent(() => import('../views/ProjectSalesAndCost.vue')),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT_SALES_COST,
      action: Actions.READ
    }
  },
  {
    path: '/other_cost_edit/:projectId/:otherCostId?/:slug(.*)?',
    name: 'otherCostEdit',
    component: () => import('../views/OtherCostEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.PROJECT_SALES_COST,
      action: Actions.READ
    }
  }
]

export default routes
